import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CContainer, CHeader, CHeaderNav, CHeaderToggler } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilMenu } from "@coreui/icons";
import { ProfileDropdown } from "./index";
import { AppBreadcrumb } from "./index";
import { useNavigate } from "react-router-dom";

const AppHeader = () => {
  const navigate = useNavigate();

  let userData = sessionStorage.getItem("token");
  useEffect(() => {
    if (!userData) {
      navigate("/login");
    }
  }, []);

  return (
    <>
      <CContainer fluid style={{ padding: 0 }}>
        <AppBreadcrumb />
      </CContainer>
    </>
  );
};

export default AppHeader;
